import { useContext, useEffect, useState } from "react";
import { BannerContext } from "../../InternalApiApp";
import { useStorage } from "../../Utils/Utils";
import Page, { PageContentBodyGrid } from "../Shared/Page/Page";
import ToggableComponent, { getSingleComponent } from "./AnalyticsUtils";
import useWindowDimensions from "../../Utils/Utils";
import PageGridDivider from "../Shared/Page/PageGridDivider";
import PageGridItem from "../Shared/Page/PageGridItem";
import Divider from "../../components/Divider";
import AnalyticsSourceSelector from "./AnalyticsSourceSelector";
import DateRangeInput from "../CraigsLibraryPage/DateRangeInput";
import "./AnalyticsPage.scss";


const AnalyticsPage = ({ tabName, content }) => {
	const storage = useStorage();
	const { width } = useWindowDimensions();
	const { dateRanges, components } = content
	const { setBannerBreadCrumbs, setBannerAdditionalContent, setBacNoDivider } = useContext(BannerContext);
	const [tabLeft, setTabLeft] = useState(content.leftDefaultSubTab)
	const [tabRight, setTabRight] = useState(content.rightDefaultSubTab)
	const [centralizedDateRange, setCentralizedDateRange] = useState(content.centralizedDateRange ? dateRanges[0] : null)
	const [customeDate, setCustomeDate] = useState(null);


	useEffect(() => {
		setBannerBreadCrumbs({ tab: tabName })
		setBacNoDivider(true)
		if (content.aditionalBannerContent) {
			storage.getOrFetch(`/analytics/aggregates/epoch`).then(fetchedDate => {
				setBannerAdditionalContent(<AdditionalBannerContent dateRanges={dateRanges} customeDate={customeDate} setCustomeDate={setCustomeDate} inceptionDate={fetchedDate}/>)
			})
		}
		return () => {
			setBacNoDivider(false)
			setBannerAdditionalContent(null)
		}
	}, [])


	function getComponent(c, isLeft) {
		if (c.toggable) return getToggableComponent(c)
		else if (c.sideBySide) return getSideBySideComponent(c, isLeft)
		else {
			const dontShow = c.showIf ? (isLeft ? c.showIf !== tabLeft : c.showIf !== tabRight) : false;
			return (dontShow
				? null
				: <>
					{c.dividerTop && <PageGridDivider col="1 / span 6" />}
					<PageGridItem col="1 / span 6">{getSingleComponent(c, dateRanges, centralizedDateRange, isLeft ? tabLeft : tabRight, isLeft ? setTabLeft : setTabRight, content.centralizedDateRange, customeDate)}</PageGridItem>
					{c.divider && <PageGridDivider col="1 / span 6" />}
				</>)
		}
	}

	function getToggableComponent(c) {
		return (
			<>
				<PageGridItem col="1 / span 6">
					<ToggableComponent dateRanges={dateRanges} options={c.options} components={c.components} centralizedDateRange={centralizedDateRange} customeDate={customeDate} />
				</PageGridItem>
				{c.divider && <PageGridDivider col="1 / span 6" />}
			</>
		)
	}

	function getSideBySideComponent(c, isLeft) {
		const dontShow = c.showIf && isLeft ? c.showIf !== tabLeft : c.showIf !== tabRight;
		return (dontShow
			? null
			: <>
				<PageGridItem col="1 / span 6" style={{ display: 'grid', gridTemplateColumns: "1fr 1px 1fr", gap: "1rem" }} subGrid>
					<div>{getSingleComponent(c.components[0], dateRanges, centralizedDateRange, null, null, content.centralizedDateRange)}</div>
					<Divider vertical height={"auto"} />
					<div>{getSingleComponent(c.components[1], dateRanges, centralizedDateRange, null, null, content.centralizedDateRange)}</div>
				</PageGridItem>
				{c.divider && <PageGridDivider col="1 / span 6" />}
			</>
		)
	}


	return (
		<Page id="analytics-page" style={{ paddingBottom: 0 }} noBanner>
			{/* LEFT SIDE GRID */}
			<PageContentBodyGrid id="analytics-page-grid" paddingTop="0px" rowGap="l" gridTemplateRows="1fr" gridTemplateColumns={width < 1200 ? '1fr' : content.gridTemplateColumns} splitScroll >
				<PageGridItem container style={{ paddingTop: "1.5rem" }}>
					<PageContentBodyGrid style={{ rowGap: content.rowGaps ? content.rowGaps[0] : "1.5rem" }} paddingBottom={"0.5rem"} gridColCount="6" subGrid>
						{components?.left.map((c) => getComponent(c, true))}
					</PageContentBodyGrid>
				</PageGridItem>
				<Divider vertical={width >= 1200} height={width >= 1200 ? "auto" : '1.25px'} style={width >= 1200 ? { margin: '1.5rem 0' } : null} />
				{/* RIGHT SIDE GRID */}
				<PageGridItem container style={{ paddingTop: width < 1200 ? "0rem" : "1.5rem", paddingBottom: width < 1200 ? '3rem' : 0 }}>
					<PageContentBodyGrid style={{ rowGap: content.rowGaps ? content.rowGaps[1] : 48 }} paddingBottom={48} gridColCount="6" subGrid>
						{components?.right.map(c => getComponent(c, false))}
					</PageContentBodyGrid>
				</PageGridItem>
			</PageContentBodyGrid>
		</Page>
	);
};

export default AnalyticsPage;

const AdditionalBannerContent = ({ dateRanges, customeDate, setCustomeDate, inceptionDate }) => {

	return (
		<div style={{ display: "flex", alignItems: "center", justifyContent: 'right', marginLeft: "auto", gap: "1rem" }}>
			<DateRangeInput onChange={setCustomeDate} value={customeDate} dateRanges={dateRanges} inceptionDate={inceptionDate} />
			<AnalyticsSourceSelector />
		</div>
	)
}